var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-js',{ref:"hlsPlayer",staticClass:"vjs-default-skin hls-player",attrs:{"data-setup":"{}"}})}
var staticRenderFns = []

export { render, staticRenderFns }